import { Routes } from '@angular/router';

export const RESULTADOS_ROUTES: Routes = [
	{
		path: 'results',
		loadComponent: () => import('./feature-historico/historico').then((m) => m.DisplayResults),
		data: { title: 'Predições' },
	},
	{
		path: 'results-predicao',
		loadComponent: () => import('./feature-resultado/resultado').then((m) => m.ResultsPredicao),
		data: { title: 'Resultado da Predição' },
	},
];
